import React from 'react';
import PropTypes from 'prop-types';

import { t } from '../../services/i18nService';
import CloseIcon from './CloseIcon';
import ViewportWarningIcon from './ViewportWarningIcon';
import styles from './App.scss';

const ViewportWarningBanner = ({ onClose }) => {
    return (
        <div className={styles.viewportWarningBanner} role="alert">
            <ViewportWarningIcon className={styles.viewportWarningIcon} />
            <div className={styles.viewportWarningContent}>
                <h2>{t('viewportRequirement.recommended.title')}</h2>
                <p>{t('viewportRequirement.recommended.body')}</p>
            </div>
            <button
                className={styles.viewportWarningCloseButton}
                onClick={onClose}
                type="button"
                aria-label={t('general.close')}
            >
                <CloseIcon className={styles.viewportWarningCloseIcon} />
            </button>
        </div>
    );
};

ViewportWarningBanner.propTypes = {
    onClose: PropTypes.func.isRequired,
};

export default ViewportWarningBanner;
